export default __webpack_public_path__ + "static/image3-4ca93be0226dcf37d65a70ad3654ca13.jpeg";